export default {"src":"/_next/static/media/aws-logoo.60ef4503.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};